export default {
  getSubscribeSkuList(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/services/subscribe_goods',
      data
    ).then(res => {
      return res;
    });
  },
  getSubscribeList(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/service_orders/',
      data
    ).then(res => {
      return res;
    });
  },
  getSubscribeDetail(id) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/service_orders/${id}`
    ).then(res => {
      return res;
    });
  },
  postSubscribeDetail(id, data) {
    return this.http(
      'Lottery',
      'post',
      `/api/v1/service_orders/${id}`,
      data
    ).then(res => {
      return res;
    });
  }
};
